module.exports = __webpack_public_path__ + "files/5531deaf6cc72572d752c000ee8a7333.png";